// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c02736b0","732":"3751ef12","952":"666ef8c5"}[chunkId] + ".chunk.js";
};